// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import styles from './styles.scss';

import { getCategory, getAttributes } from '../../utils/methods.js';
import StaffMember from './StaffMember';
import Owner from './Owner';

import { preloader } from '../../utils/animation';

import type { ItemType, CategoryType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';

type Props = {
  categories: Array<CategoryType>,
};

type State = {
  activeTab: string,
};

class AboutUs extends React.Component<Props, State> {
  state = {
    activeTab: 'company',
  };

  handleTabChange = (activeTab: string) => {
    this.setState({ activeTab });
    // $FlowFixMe
    document.body.classList.remove('company');
    // $FlowFixMe
    document.body.classList.remove('staff');
    // $FlowFixMe
    document.body.classList.add(activeTab);
  };

  componentDidMount() {
    preloader().play();
    // $FlowFixMe
    document.body.classList.add('about');
    // $FlowFixMe
    document.body.classList.add(this.state.activeTab);
  }

  componentWillUnmount() {
    // $FlowFixMe
    document.body.classList.remove('about');
    // $FlowFixMe
    document.body.classList.remove(this.state.activeTab);
  }

  getOwnersAndStaff = (category: ?CategoryType): { owners: Array<ItemType>, staff: Array<ItemType> } => {
    let owners = [];
    let staff = [];

    if (category && category.items && category.items.length > 0) {
      category.items.forEach(
        item => (item.name.toLowerCase().includes('owner') ? owners.push(item) : staff.push(item)),
      );
    }

    return { owners, staff };
  };

  render() {
    const { categories } = this.props;

    if (!categories) {
      return <div>loading...</div>;
    }

    const { activeTab } = this.state;

    const category = getCategory(categories, 'about us');
    const attributes = getAttributes(category);

    const { owners, staff } = this.getOwnersAndStaff(category);

    const title = attributes.find(attr => attr.name === 'title');
    const description = attributes.find(attr => attr.name === 'description');

    return (
      <React.Fragment>
        <div className={styles.hero}>
          <div className="aside">
            <div className={styles.tabsToggle}>
              <ul>
                <li
                  onClick={(): void => this.handleTabChange('company')}
                  className={classnames({ active: activeTab === 'company' })}
                >
                  <span>Company</span>
                </li>
                <li
                  onClick={(): void => this.handleTabChange('staff')}
                  className={classnames({ active: activeTab === 'staff' })}
                >
                  <span>Staff</span>
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.title}>
            <h1>About Us</h1>
          </div>

          <div className="aside" />
        </div>
        <div className={styles.content}>
          <div className={classnames(styles['company-tab'], { active: activeTab === 'company' })}>
            {title && title.value ? <h2>{title.value}</h2> : null}
            {description && description.value ? <p>{description.value}</p> : null}
          </div>

          <div className={classnames(styles['staff-tab'], { active: activeTab === 'staff' })}>
            {owners.length > 0 && (
              <React.Fragment>
                <h3>Owners</h3>

                <div className={styles.owners}>
                  {owners.map(owner => (
                    <Owner key={owner.name} owner={owner} />
                  ))}
                </div>
              </React.Fragment>
            )}

            {/*<h3>Staff</h3>*/}
            {/*{staff.length > 0 && staff.map(member => <StaffMember key={member.name} member={member} />)}*/}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: DefaultStateType) => ({ categories: state.categories });

export default connect(mapStateToProps)(AboutUs);



// WEBPACK FOOTER //
// ./src/pages/AboutUs/index.js